import React from "react";
import { Actionable, Banner, Icon, Image, Stack, Text } from "@bookingcom/bui-react";
import { useI18n } from "@bookingcom/lingojs-react";
import { useFormatDateTime } from "@bookingcom/flights-core";
import styles from "./WeekendGetawaysItemInner.module.css";
import { PlaneTripTimeIcon } from "@bookingcom/bui-assets-react/streamline";
import { t } from "@bookingcom/lingojs-core";
import useClientMetrics from "hooks/useClientMetrics";
import useLandingPageEvents from "hooks/c360/useLandingPageEvents";

type Props = {
  linkUrlSR: string;
  arrivalCityImageUrl: string;
  arrivalCityNameTranslated: string;
  departureDate: string;
  returnDepartureDate: string;
  price: string;
  durationCopy: string;
};

const WeekendGetawaysItemInnerMobile = ({
  linkUrlSR,
  arrivalCityImageUrl,
  arrivalCityNameTranslated,
  departureDate,
  returnDepartureDate,
  price,
  durationCopy
}: Props) => {
  const i18n = useI18n();
  const { formats } = useFormatDateTime(i18n);
  const { trackClientMetric } = useClientMetrics();
  const trackLandingPageEvents = useLandingPageEvents();

  const handleClick = () => {
    trackClientMetric("weekend_getaway_click_card");
    trackLandingPageEvents("click", "weekend_getaways");
  };

  return (
    <Actionable href={linkUrlSR} attributes={{ style: { display: "block" } }} onClick={handleClick}>
      <Banner dismissible={false} className={styles.banner}>
        <Stack direction="row" wrap="nowrap" gap={0}>
          <Image src={arrivalCityImageUrl} className={styles.left} fallback="icon" />
          <Stack.Item className={styles.right}>
            <Stack direction="column" gap={0} justifyContent="space-between" wrap="wrap">
              <Text variant="small_1" color="neutral">
                <Icon svg={PlaneTripTimeIcon} size="smaller" className={styles.icon} /> {durationCopy}
              </Text>
              <Stack.Item className={styles.city}>
                <Text variant="strong_2" color="neutral">
                  {arrivalCityNameTranslated}
                </Text>
                <Text variant="small_1" color="neutral">
                  {formats.flightDateWeekday(departureDate)} - {formats.flightDateWeekday(returnDepartureDate)}
                </Text>
              </Stack.Item>
              <Stack direction="row" alignItems="baseline" className={styles.priceWrapper} wrap="wrap">
                <Text variant="strong_1" color="neutral" className={styles.price}>
                  {price}
                </Text>
                <Text variant="small_1" color="neutral_alt">
                  {i18n.trans(t("flights_cheap_weekend_carousel_price"))}
                </Text>
              </Stack>
            </Stack>
          </Stack.Item>
        </Stack>
      </Banner>
    </Actionable>
  );
};

export default WeekendGetawaysItemInnerMobile;
